import React, { createContext, useContext, ReactNode } from "react";

/**
 * Site areas as used for GA event categories.
 * Formatted to look beautiful in GA's events UI.
 */
export enum SiteArea {
  ABOUT = "About",
  ACCESSIBILITY = "Accessibility",
  BUY = "Buy",
  DESIGN_CHALLENGES = "Design challenges",
  DO_YOUR_BIT = "Do your :bit",
  GET_STARTED = "Get started",
  HOME = "Home",
  IMPACT = "Impact",
  LESSONS = "Lessons",
  MAKE_IT_CODE_IT = "Make it: code it",
  NEWS = "News",
  PLAYGROUND_ACTIVITY_CODING_GUIDES = "Playground activity coding guides",
  PROJECTS = "Projects",
  TEACH = "Teach",
  UNKNOWN = "Unknown"
}

export interface AnalyticsContextState {
  siteArea: SiteArea;
}

const AnalyticsContext = createContext<AnalyticsContextState>({
  siteArea: SiteArea.UNKNOWN
});

export const useAnalyticsContext = () => useContext(AnalyticsContext);

export interface AnalyticsProviderProps {
  siteArea: SiteArea;
  children: ReactNode;
}

export const AnalyticsProvider = ({
  siteArea,
  children
}: AnalyticsProviderProps) => (
  <AnalyticsContext.Provider value={{ siteArea }}>
    {children}
  </AnalyticsContext.Provider>
);
